var handleModalFilters = require('./handle-modal-filters');

module.exports = function (apiEndpoint) {
    $('body').on('click', '.search-rendering__mobile-view-results-button', function (e) {
        e.preventDefault();
        $('.search-rendering__modaal-filters-link').modaal('close');
    });

    handleModalFilters(apiEndpoint);
};